// extracted by mini-css-extract-plugin
module.exports = {"galleryTransformer":"gallery-transformer-module--gallery-transformer--3vA89","masonryGrid":"gallery-transformer-module--masonry-grid--FUDI4"};